import Main from "@/view/Main.vue";
import MainTwo from "@/view/MainTwo.vue";

// 因需要右键可以新窗口打开，被迫无奈，只能每个路由写两次。。。后期开发如果有更好的办法，麻烦修改下，感谢
export const loginRouter = {
    path: "/login",
    name: "login",
    meta: {
        title: "经销商管理系统登录"
    },
    component: resolve => require(['@/components/Login.vue'], resolve)
};

export const QrcodeRouter = {
  path: "/QrcodeRouter",
  name: "QrcodeRouter",
  meta: {title: "文章预览"},
  component: resolve => require(['@/components/Qrcode.vue'], resolve),
};


export const registerRouter = {
    path: "/register",
    name: "register",
    meta: {
        title: "用户注册"
    },
    component: resolve => require(['@/components/Register.vue'], resolve)
};

export const IndexRouter = {
    path: "/",
    name: "IndexRouter",
    component: Main,
    redirect: "/Index/MyTask",
    children: [{
      path: "/Index/Home",
      name: "Home",
      meta: {title: "经销商管理系统"},
      component: resolve => require(['@/view/Index/Home.vue'], resolve)
    }, {
        path: "/Index/MyArticle",
        name: "MyArticle",
        meta: {title: "经销商管理系统"},
        component: resolve => require(['@/view/Index/MyArticle.vue'], resolve)
      },{
        path: "Index",
        name: "Index",
        meta: {title: "经销商管理系统"},
        component: resolve => require(['@/view/Index/Index.vue'], resolve),
        children: [{
            path: "MyTask",
            name: "MyTask",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/Index/MyTask.vue'], resolve)
        }, {
            path: "MyApply",
            name: "MyApply",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/Index/MyApply.vue'], resolve)
        }, {
            path: "MyDraft",
            name: "MyDraft",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/Index/MyDraft.vue'], resolve)
        },{
          path: "MyArticleList",
          name: "MyArticleList",
          meta: {title: "经销商管理系统"},
          component: resolve => require(['@/view/Index/MyArticleList.vue'], resolve)
        },{
          path: "MyDepartment",
          name: "MyDepartment",
          meta: {title: "经销商管理系统"},
          component: resolve => require(['@/view/Index/MyDepartment.vue'], resolve)
        },{
            path: "MyInformation",
            name: "MyInformation",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/Index/MyInformation.vue'], resolve)
        },{
          path: "MyTab",
          name: "MyTab",
          meta: {title: "经销商管理系统"},
          component: resolve => require(['@/view/Index/MyTab.vue'], resolve)
        },{
            path: "Record",
            name: "Record",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/Index/EmpowermentRecord.vue'], resolve)
        }]
    }
    ]
};

//二期
export const IndexTwoRouter = {
    path: "/",
    name: "IndexTwoRouter",
    component: MainTwo,
    redirect: "/IndexTwo/MyTaskTwo",
    children: [{
        path: "IndexTwo",
        name: "IndexTwo",
        meta: {title: "经销商管理系统"},
        component: resolve => require(['@/view/IndexTwo/IndexTwo.vue'], resolve),
        children: [{
            path: "MyTaskTwo",
            name: "MyTaskTwo",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/IndexTwo/MyTaskTwo.vue'], resolve)
        }, {
            path: "MyApplyTwo",
            name: "MyApplyTwo",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/IndexTwo/MyApplyTwo.vue'], resolve)
        }, {
            path: "MyDraftTwo",
            name: "MyDraftTwo",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/IndexTwo/MyDraftTwo.vue'], resolve)
        }, {
            path: "RecordTwo",
            name: "RecordTwo",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/IndexTwo/EmpowermentRecordTwo.vue'], resolve)
        }]
    }
    ]
};

export const WorkflowTwoRouter = {
    path: "/",
    component: Main,
    name: "WorkflowRouter",
    // redirect: '/home',
    meta: {
        title: "经销商管理系统"
    },
    children: [{
        path: "/Workflow",
        name: "/Workflow",
        meta: {title: "经销商管理系统"},
        component: resolve => require(['@/view/WorkflowTwo/IndexTwo.vue'], resolve),
        children: [{
            path: "Index",
            name: "workflowindex",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/Workflow/workflowmenu.vue'], resolve)
        }],
    },

      {
        path: "/Index/MyForm/:Action",
        name: "MyForm",
        meta: {title: "经销商管理系统"},
        component: resolve => require(['@/view/Index/MyForm.vue'], resolve)
      },
      // 合同模板更新
      {
        path: "ContractTemplate/:Action",
        name: "ContractTemplate",
        meta: {title: "经销商管理系统"},
        component: resolve => require(['@/view/WorkflowTwo/ContractTemplate/ContractTemplate.vue'], resolve)
      },
      {
        path: "DdRenewal/:Action",
        name: "DdRenewal",
        meta: {title: "经销商管理系统"},
        component: resolve => require(['@/view/WorkflowTwo/DdRenewal/DdRenewal.vue'], resolve)
    }, {
        path: "Index/DdRenewal/:Action",
        name: "DdRenewal",
        meta: {title: "经销商管理系统"},
        component: resolve => require(['@/view/WorkflowTwo/DdRenewal/DdRenewal.vue'], resolve)
    }, {
        path: "Termination/:Action",
        name: "Termination",
        meta: {title: "经销商管理系统"},
        component: resolve => require(['@/view/WorkflowTwo/Termination/Termination.vue'], resolve)

    }, {
        path: "Index/Termination/:Action",
        name: "Termination",
        meta: {title: "经销商管理系统"},
        component: resolve => require(['@/view/WorkflowTwo/Termination/Termination.vue'], resolve)

    }, {
        path: "RelatedCompany/:Action",
        name: "RelatedCompany",
        meta: {title: "经销商管理系统"},
        component: resolve => require(['@/view/WorkflowTwo/RelatedCompany/RelatedCompany.vue'], resolve)

    }, {
        path: "Index/RelatedCompany/:Action",
        name: "RelatedCompany",
        meta: {title: "经销商管理系统"},
        component: resolve => require(['@/view/WorkflowTwo/RelatedCompany/RelatedCompany.vue'], resolve)

    }, {
        path: "FirstAuthorizationChange/:Action",
        name: "FirstAuthorizationChange",
        meta: {title: "经销商管理系统"},
        component: resolve => require(['@/view/WorkflowTwo/FirstAuthorizationChange/FirstAuthorizationChange.vue'], resolve)

    }, {
        path: "Index/FirstAuthorizationChange/:Action",
        name: "FirstAuthorizationChange",
        meta: {title: "经销商管理系统"},
        component: resolve => require(['@/view/WorkflowTwo/FirstAuthorizationChange/FirstAuthorizationChange.vue'], resolve)

    }, {
        path: "SpecialAuthorization/:Action",
        name: "SpecialAuthorization",
        meta: {title: "经销商管理系统"},
        component: resolve => require(['@/view/WorkflowTwo/SpecialAuthorization/SpecialAuthorization.vue'], resolve)

    }, {
        path: "Index/SpecialAuthorization/:Action",
        name: "SpecialAuthorization",
        meta: {title: "经销商管理系统"},
        component: resolve => require(['@/view/WorkflowTwo/SpecialAuthorization/SpecialAuthorization.vue'], resolve)

    }
        , {
            path: "Jurisdiction/:Action",
            name: "Jurisdiction",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/Jurisdiction/Jurisdiction.vue'], resolve)
        }, {
            path: "Index/Jurisdiction/:Action",
            name: "Jurisdiction",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/Jurisdiction/Jurisdiction.vue'], resolve)
        }, {
            path: "DataChange/:Action",
            name: "DataChange",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/DataChange/DataChange.vue'], resolve)
        }, {
            path: "Index/DataChange/:Action",
            name: "DataChange",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/DataChange/DataChange.vue'], resolve)
        }, {
            path: "ChangeSubDistributorProcess/:Action",
            name: "ChangeSubDistributorProcess",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/ChangeSubDistributorProcess/ChangeSubDistributorProcess.vue'], resolve)
        }, {
            path: "Index/ChangeSubDistributorProcess/:Action",
            name: "ChangeSubDistributorProcess",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/ChangeSubDistributorProcess/ChangeSubDistributorProcess.vue'], resolve)
        },

        //次级经销商管理
        {
            path: "SecondaryDealerNew/:Action",
            name: "SecondaryDealerNew",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/SecondDealerNew/SecondDealerNew.vue'], resolve)
        },
        //次级经销商管理
        {
            path: "Index/SecondaryDealerNew/:Action",
            name: "SecondaryDealerNew",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/SecondDealerNew/SecondDealerNew.vue'], resolve)
        },
        {
            path: "SecondDealerRenewal/:Action",
            name: "SecondDealerRenewal",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/SecondDealerRenewal/SecondDealerRenewal.vue'], resolve)
        },
        {
            path: "Index/SecondDealerRenewal/:Action",
            name: "SecondDealerRenewal",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/SecondDealerRenewal/SecondDealerRenewal.vue'], resolve)
        },
        {
            path: "SecondAuthorizationIndicators/:Action",
            name: "SecondAuthorizationIndicators",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/SecondAuthorizationIndicators/SecondAuthorizationIndicators.vue'], resolve)
        },
        {
            path: "Index/SecondAuthorizationIndicators/:Action",
            name: "SecondAuthorizationIndicators",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/SecondAuthorizationIndicators/SecondAuthorizationIndicators.vue'], resolve)
        },{
            path: "NewSecondAuthorizationIndicators/:Action",
            name: "NewSecondAuthorizationIndicators",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/NewSecondAuthorizationIndicators/SecondAuthorizationIndicators.vue'], resolve)
        },
        {
            path: "Index/NewSecondAuthorizationIndicators/:Action",
            name: "NewSecondAuthorizationIndicators",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/NewSecondAuthorizationIndicators/SecondAuthorizationIndicators.vue'], resolve)
        },
        {
            path: "DelegatePageAuthorization",
            name: "DelegatePageAuthorization",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/SecondAuthorizationIndicators/DelegatePageAuthorization.vue'], resolve)
        },
        {
            path: "Index/DelegatePageAuthorization",
            name: "DelegatePageAuthorization",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/SecondAuthorizationIndicators/DelegatePageAuthorization.vue'], resolve)
        },
        {
            path: "SecondaryDealerAuthorizationChangeProcess/:Action",
            name: "SecondaryDealerAuthorizationChangeProcess",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/SecondaryDealerAuthorizationChangeProcess/SecondaryDealerAuthorizationChangeProcess.vue'], resolve)
        },
        {
            path: "Index/SecondaryDealerAuthorizationChangeProcess/:Action",
            name: "SecondaryDealerAuthorizationChangeProcess",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/SecondaryDealerAuthorizationChangeProcess/SecondaryDealerAuthorizationChangeProcess.vue'], resolve)
        },
        {
            path: "SecondaryDealerQualificationChangeApprovalProcess/:Action",
            name: "SecondaryDealerQualificationChangeApprovalProcess",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/SecondaryDealerQualificationChangeApprovalProcess/SecondaryDealerQualificationChangeApprovalProcess.vue'], resolve)
        },
        {
            path: "Index/SecondaryDealerQualificationChangeApprovalProcess/:Action",
            name: "SecondaryDealerQualificationChangeApprovalProcess",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/SecondaryDealerQualificationChangeApprovalProcess/SecondaryDealerQualificationChangeApprovalProcess.vue'], resolve)
        },
        {
            path: "SecondaryDealerInformationChangeWithoutProcess/:Action",
            name: "SecondaryDealerInformationChangeWithoutProcess",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/SecondaryDealerInformationChangeWithoutProcess/SecondaryDealerInformationChangeWithoutProcess.vue'], resolve)
        },
        {
            path: "Index/SecondaryDealerInformationChangeWithoutProcess/:Action",
            name: "SecondaryDealerInformationChangeWithoutProcess",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/SecondaryDealerInformationChangeWithoutProcess/SecondaryDealerInformationChangeWithoutProcess.vue'], resolve)
        }, {
            path: "CertificatesChange/:Action",
            name: "CertificatesChange",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/CertificatesChange/CertificatesChange.vue'], resolve)
        }, {
            path: "Index/CertificatesChange/:Action",
            name: "CertificatesChange",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/CertificatesChange/CertificatesChange.vue'], resolve)
        },
        {
            path: "ServicePersonalChange/:Action",
            name: "ServicePersonalChange",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/ServicePersonalChange/ServicePersonalChange.vue'], resolve)
        },
        {
            path: "Index/ServicePersonalChange/:Action",
            name: "ServicePersonalChange",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/ServicePersonalChange/ServicePersonalChange.vue'], resolve)
        }, {
            path: "WarehousesChange/:Action",
            name: "WarehousesChange",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/WarehousesChange/WarehousesChange.vue'], resolve)
        }, {
            path: "Index/WarehousesChange/:Action",
            name: "WarehousesChange",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/WarehousesChange/WarehousesChange.vue'], resolve)
        }, {
            path: "OneQualificationsChange/:Action",
            name: "OneQualificationsChange",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/OneQualificationsChange/OneQualificationsChange.vue'], resolve)
        }, {
            path: "Index/OneQualificationsChange/:Action",
            name: "OneQualificationsChange",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/OneQualificationsChange/OneQualificationsChange.vue'], resolve)
        }, {
            path: "InvoiceChange/:Action",
            name: "InvoiceChange",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/InvoiceChange/InvoiceChange.vue'], resolve)
        }, {
            path: "Index/InvoiceChange/:Action",
            name: "InvoiceChange",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/InvoiceChange/InvoiceChange.vue'], resolve)
        },{
            path: "ProvideInvoiceChange/:Action",
            name: "ProvideInvoiceChange",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/ProvideInvoiceChange/InvoiceChange.vue'], resolve)
        }, {
            path: "Index/ProvideInvoiceChange/:Action",
            name: "ProvideInvoiceChange",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/ProvideInvoiceChange/InvoiceChange.vue'], resolve)
        }, {
            path: "ServiceProviderInvoiceChange/:Action",
            name: "ServiceProviderInvoiceChange",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/ServiceProviderInvoiceChange/ServiceProviderInvoiceChange.vue'], resolve)
        }, {
            path: "Index/ServiceProviderInvoiceChange/:Action",
            name: "ServiceProviderInvoiceChange",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/ServiceProviderInvoiceChange/ServiceProviderInvoiceChange.vue'], resolve)
        }, {
            path: "ManagementChange/:Action",
            name: "ManagementChange",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/ManagementChange/ManagementChange.vue'], resolve)
        }, {
            path: "Index/ManagementChange/:Action",
            name: "ManagementChange",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/ManagementChange/ManagementChange.vue'], resolve)
        }, {
            path: "ServiceProviderManagementChange/:Action",
            name: "ServiceProviderManagementChange",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/ServiceProviderManagementChange/ServiceProviderManagementChange.vue'], resolve)
        }, {
            path: "Index/ServiceProviderManagementChange/:Action",
            name: "ServiceProviderManagementChange",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/ServiceProviderManagementChange/ServiceProviderManagementChange.vue'], resolve)
        }, {
            path: "BusinessContactsChange/:Action",
            name: "BusinessContactsChange",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/BusinessContactsChange/BusinessContactsChange.vue'], resolve)
        }, {
            path: "Index/BusinessContactsChange/:Action",
            name: "BusinessContactsChange",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/BusinessContactsChange/BusinessContactsChange.vue'], resolve)
        }, {
            path: "ServiceProviderBusinessContactsChange/:Action",
            name: "ServiceProviderBusinessContactsChange",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/ServiceProviderBusinessContactsChange/ServiceProviderBusinessContactsChange.vue'], resolve)
        }, {
            path: "Index/ServiceProviderBusinessContactsChange/:Action",
            name: "ServiceProviderBusinessContactsChange",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/ServiceProviderBusinessContactsChange/ServiceProviderBusinessContactsChange.vue'], resolve)
        }, {
            path: "agreement/:Action",
            name: "agreement",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/agreement/DistributorMaster.vue'], resolve)
        }, {
            path: "Index/agreement/:Action",
            name: "agreement",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/agreement/DistributorMaster.vue'], resolve)
        }, {
            path: "otherAgreements/:Action",
            name: "otherAgreements",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/otherAgreements/otherAgreements.vue'], resolve)
        }, {
            path: "Index/otherAgreements/:Action",
            name: "otherAgreements",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/otherAgreements/otherAgreements.vue'], resolve)
        }, {
            path: "Index/affiliatedCompanies/:Action",
            name: "affiliatedCompanies",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/affiliatedCompanies/affiliatedCompanies.vue'], resolve)
        }, {
            path: "Index/providerPersonnelAdd/:Action",
            name: "providerPersonnelAdd",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/providerPersonnelAdd/providerPersonnelAdd.vue'], resolve)
        }, {
            path: "Index/providerPersonnelContractRenewal/:Action",
            name: "providerPersonnelContractRenewal",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/providerPersonnelContractRenewal/providerPersonnelContractRenewal.vue'], resolve)
        }, {
            path: "Index/ProvideCertificateChange/:Action",
            name: "ProvideCertificateChange",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/ProvideCertificateChange/ProvideCertificateChange.vue'], resolve)
        }, {
            path: "Index/providerPersonnelEnd/:Action",
            name: "providerPersonnelEnd",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/WorkflowTwo/providerPersonnelEnd/providerPersonnelEnd.vue'], resolve)
        }, {
            path: "Index/NewSubServiceProvider/:Action",
            name: "NewSubServiceProvider",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/subService/NewSubServiceProvider.vue'], resolve)
        }, {
            path: "Index/SubServiceProviderChange/:Action",
            name: "SubServiceProviderChange",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/SubServiceProviderChange/SubServiceProviderChange.vue'], resolve)
        }, {
            path: "Index/SubServiceQualificationChange/:Action",
            name: "SubServiceQualificationChange",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/SubServiceQualificationChange/SubServiceQualificationChange.vue'], resolve)
        }, {
            path: "Index/SubServiceDataChange/:Action",
            name: "SubServiceDataChange",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/SubServiceDataChange/SubServiceDataChange.vue'], resolve)
        },{
            path: "Index/serviceBatch/:Action",
            name: "serviceBatch",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/serviceBatch/serviceBatch.vue'], resolve)
        }

    ]
}

export const DistributorRouter = {
    path: "/",
    component: Main,
    name: "DistributorRouter",
    // redirect: '/home',
    meta: {
        title: "经销商管理系统"
    },
    children: [{
        path: "distributor",
        name: "distributor",
        meta: {title: "经销商管理系统"},
        component: resolve => require(['@/view/Distributor/Index.vue'], resolve),
        children: [
            {
                path: "distributormaster",
                name: "distributormaster",
                meta: {title: "经销商管理系统"},
                component: resolve => require(['@/view/Distributor/DistributorMaster.vue'], resolve)
            }
        ]
    },
        {
            path: "Search",
            name: "distributor",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/Distributor/Index.vue'], resolve),
            children: [
                {
                    path: "distributormaster",
                    name: "distributormaster",
                    meta: {title: "经销商管理系统"},
                    component: resolve => require(['@/view/Distributor/DistributorMaster.vue'], resolve)
                }
            ]
        }]
};

export const DistributorTwoRouter = {
    path: "/",
    component: Main,
    name: "DistributorTwoRouter",
    // redirect: '/home',
    meta: {
        title: "经销商管理系统"
    },
    children: [{
        path: "distributortwo",
        name: "distributortwo",
        meta: {title: "经销商管理系统"},
        component: resolve => require(['@/view/DistributorTwo/DistributorTwoMaster.vue'], resolve),
        children: [
            {
                path: "DistributorTwoMaster",
                name: "DistributorTwoMaster",
                meta: {title: "经销商管理系统"},
                component: resolve => require(['@/view/DistributorTwo/DistributorTwoMaster.vue'], resolve)
            }
        ]
    }, {
        path: "Search",
        name: "distributortwo",
        meta: {title: "经销商管理系统"},
        component: resolve => require(['@/view/DistributorTwo/DistributorTwoMaster.vue'], resolve),
        children: [
            {
                path: "DistributorTwoMaster",
                name: "DistributorTwoMaster",
                meta: {title: "经销商管理系统"},
                component: resolve => require(['@/view/DistributorTwo/DistributorTwoMaster.vue'], resolve)
            }
        ]
    }]
};

export const DistributorSecondRouter = {
    path: "/",
    component: Main,
    name: "DistributorSecondRouter",
    // redirect: '/home',
    meta: {
        title: "经销商管理系统"
    },
    children: [{
        path: "distributorsecond",
        name: "distributorsecond",
        meta: {title: "经销商管理系统"},
        component: resolve => require(['@/view/DistributorSecond/DistributorSecond.vue'], resolve),
        children: [
            {
                path: "DistributorSecond",
                name: "DistributorSecond",
                meta: {title: "经销商管理系统"},
                component: resolve => require(['@/view/DistributorSecond/DistributorSecond.vue'], resolve)
            }
        ]
    }, {
        path: "Search",
        name: "distributorsecond",
        meta: {title: "经销商管理系统"},
        component: resolve => require(['@/view/DistributorSecond/DistributorSecond.vue'], resolve),
        children: [
            {
                path: "DistributorSecond",
                name: "DistributorSecond",
                meta: {title: "经销商管理系统"},
                component: resolve => require(['@/view/DistributorSecond/DistributorSecond.vue'], resolve)
            }
        ]
    }, {
        path: "Tool",
        name: "DealerSalesUpdate",
        meta: {title: "经销商管理系统"},
        component: resolve => require(['@/view/DealerSalesUpdate/DealerSalesUpdate.vue'], resolve),
        children: [
            {
                path: "DealerSalesUpdate",
                name: "DealerSalesUpdate",
                meta: {title: "经销商管理系统"},
                component: resolve => require(['@/view/DealerSalesUpdate/DealerSalesUpdate.vue'], resolve)
            }
        ]
    }, {
        path: "Tool",
        name: "DealerInventoryUpdate",
        meta: {title: "经销商管理系统"},
        component: resolve => require(['@/view/DealerInventoryUpdate/DealerInventoryUpdate.vue'], resolve),
        children: [
            {
                path: "DealerInventoryUpdate",
                name: "DealerInventoryUpdate",
                meta: {title: "经销商管理系统"},
                component: resolve => require(['@/view/DealerInventoryUpdate/DealerInventoryUpdate.vue'], resolve)
            }
        ]
    }, {
        path: "Search",
        name: "distributorsecond1",
        meta: {title: "经销商管理系统"},
        component: resolve => require(['@/view/Form/DelegatePageSecond.vue'], resolve),
        children: [
            {
                path: "DelegatePageSecond",
                name: "DelegatePageSecond",
                meta: {title: "经销商管理系统"},
                component: resolve => require(['@/view/Form/DelegatePageSecond.vue'], resolve)
            }
        ]
    }]
};

export const SearchRouter = {
    path: "/",
    component: Main,
    name: "SearchRouter",
    // redirect: '/home',
    meta: {
        title: "经销商管理系统"
    },
    children: [{
        path: "Search",
        name: "Search",
        meta: {title: "经销商管理系统"},
        component: resolve => require(['@/view/Search/Index.vue'], resolve),
        children: [{
            path: "Distributorinformation",
            name: "Distributorinformation",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/Search/DistributorPage.vue'], resolve)
        }, {
            path: "Delegateinformation",
            name: "Delegateinformation",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/Search/DelegatePage.vue'], resolve)
        },
            {
                path: "DistributorZimmer",
                name: "DistributorZimmer",
                meta: {title: "经销商管理系统"},
                component: resolve => require(['@/view/Search/DistributorZimmer.vue'], resolve)
            },
            {
                path: "SecondaryDelegateinformation",
                name: "SecondaryDelegateinformation",
                meta: {title: "经销商管理系统"},
                component: resolve => require(['@/view/Search/SecondaryDelegateinformation.vue'], resolve)
            }, {
                path: "DelegateSecond",
                name: "DelegateSecond",
                meta: {title: "经销商管理系统"},
                component: resolve => require(['@/view/Search/DelegatePageSecond.vue'], resolve)
            }, {
                path: "DelegateOne",
                name: "DelegateOne",
                meta: {title: "经销商管理系统"},
                component: resolve => require(['@/view/Search/DelegateOne.vue'], resolve)
            }, {
                path: "DuplicateAuthorization",
                name: "DuplicateAuthorization",
                meta: {title: "经销商管理系统"},
                component: resolve => require(['@/view/Search/DuplicateAuthorization.vue'], resolve)
            }, {
                path: "Affiliated",
                name: "Affiliated",
                meta: {title: "经销商管理系统"},
                component: resolve => require(['@/view/Search/Affiliated.vue'], resolve)
            }, {
                path: "Opinion",
                name: "Opinion",
                meta: {title: "经销商管理系统"},
                component: resolve => require(['@/view/Search/Opinion.vue'], resolve)
            }, {
                path: "cooperation",
                name: "cooperation",
                meta: {title: "经销商管理系统"},
                component: resolve => require(['@/view/Search/cooperation.vue'], resolve)
            }, {
                path: "endCompany",
                name: "endCompany",
                meta: {title: "经销商管理系统"},
                component: resolve => require(['@/view/Search/endCompany.vue'], resolve)
            }, {
                path: "provider_personnel",
                name: "provider_personnel",
                meta: {title: "经销商管理系统"},
                component: resolve => require(['@/view/Search/providerPersonnel.vue'], resolve)
            }, {
              path: "DDRecord",
              name: "DDRecord",
              meta: {title: "经销商管理系统"},
              component: resolve => require(['@/view/Search/DDRecord.vue'], resolve)
            }, {
            path: "InformationAndFeedback",
            name: "InformationAndFeedback",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/Search/InformationAndFeedback.vue'], resolve)
          }, {
              path: "infoReadReport",
              name: "infoReadReport",
              meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/Search/infoReadReport.vue'], resolve)
          },{
            path: "InformationReleaseRecords",
            name: "InformationReleaseRecords",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/Search/InformationReleaseRecords.vue'], resolve)
          },{
                path: "InfoReceive",
                name: "InfoReceive",
                meta: {title: "经销商管理系统"},
                component: resolve => require(['@/view/Search/InfoReceive.vue'], resolve)
            },{
                path: "AccountNumber",
                name: "AccountNumber",
                meta: {title: "经销商管理系统"},
                component: resolve => require(['@/view/Search/AccountNumber.vue'], resolve)
            },{
                path: "AuthorizationReport",
                name: "AuthorizationReport",
                meta: {title: "经销商管理系统"},
                component: resolve => require(['@/view/Search/AuthorizationReport.vue'], resolve)
            }
        ]
    }]
};

export const FromPage = {
    path: "/",
    component: Main,
    name: "FromPage",
    // redirect: '/home',
    meta: {
        title: "经销商管理系统"
    },
    children: [{
        path: "DelegatePage",
        name: "DelegatePage",
        meta: {title: "经销商管理系统"},
        component: resolve => require(['@/view/Form/DelegatePage.vue'], resolve)
    }, {
        path: "Search/DelegatePage",
        name: "DelegatePage",
        meta: {title: "经销商管理系统"},
        component: resolve => require(['@/view/Form/DelegatePage.vue'], resolve)
    }, {
        path: "TargetPage",
        name: "TargetPage",
        meta: {title: "经销商管理系统"},
        component: resolve => require(['@/view/Form/TargetPage.vue'], resolve)
    }, {
        path: "Search/TargetPage",
        name: "TargetPage",
        meta: {title: "经销商管理系统"},
        component: resolve => require(['@/view/Form/TargetPage.vue'], resolve)
    }, {
        path: "DelegatePageSecond",
        name: "DelegatePageSecond",
        meta: {title: "经销商管理系统"},
        component: resolve => require(['@/view/Form/DelegatePageSecond.vue'], resolve)
    }, {
        path: "DelegatePageOne",
        name: "DelegatePageOne",
        meta: {title: "经销商管理系统"},
        component: resolve => require(['@/view/Form/DelegatePageOne.vue'], resolve)
    }, {
        path: "Search/showCooperation",
        name: "showCooperation",
        meta: {title: "经销商管理系统"},
        component: resolve => require(['@/view/Form/showCooperation.vue'], resolve)
    }]
};

export const WorkflowRouter = {
    path: "/",
    component: Main,
    name: "WorkflowRouter",
    // redirect: '/home',
    meta: {
        title: "经销商管理系统"
    },
    children: [{
        path: "Workflow",
        name: "Workflow",
        meta: {title: "经销商管理系统"},
        component: resolve => require(['@/view/Workflow/Index.vue'], resolve),
        children: [{
            path: "Index",
            name: "workflowindex",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/Workflow/workflowmenu.vue'], resolve)
        }]
    }, {
        path: "EmpowermentProcess/:Action",
        name: "EmpowermentProcess",
        meta: {title: "经销商管理系统"},
        component: resolve => require(['@/view/Workflow/Empowerment/EmpowermentProcess.vue'], resolve)
    }, {
        path: "Index/EmpowermentProcess/:Action",
        name: "EmpowermentProcess",
        meta: {title: "经销商管理系统"},
        component: resolve => require(['@/view/Workflow/Empowerment/EmpowermentProcess.vue'], resolve),
    }, {
        path: "VendorProcess/:Action",
        name: "VendorProcess",
        meta: {title: "经销商管理系统"},
        component: resolve => require(['@/view/Workflow/Vendor/VendorProcess.vue'], resolve)
    }, {
        path: "Index/VendorProcess/:Action",
        name: "VendorProcess",
        meta: {title: "经销商管理系统"},
        component: resolve => require(['@/view/Workflow/Vendor/VendorProcess.vue'], resolve)
    }, {
        path: "EmpowermentChange/:Action",
        name: "EmpowermentChange",
        meta: {title: "经销商管理系统"},
        component: resolve => require(['@/view/Workflow/EmpowermentChange/EmpowermentChange.vue'], resolve)
    }, {
        path: "Index/EmpowermentChange/:Action",
        name: "EmpowermentChange",
        meta: {title: "经销商管理系统"},
        component: resolve => require(['@/view/Workflow/EmpowermentChange/EmpowermentChange.vue'], resolve)
    }
    ]

};

export const InitRouter = {
    path: "/",
    component: Main,
    name: "InitHistory",
    // redirect: '/home',
    meta: {
        title: "经销商管理系统"
    },
    children: [{
        path: "Init",
        name: "Init",
        meta: {title: "经销商管理系统"},
        component: resolve => require(['@/view/InitPage/Index.vue'], resolve),
        children: [
            {
                path: "Vendor",
                name: "Vendor",
                meta: {title: "经销商管理系统"},
                component: resolve => require(['@/view/InitPage/DistributorMaster.vue'], resolve)
            }
        ]
    }]
};

export const page403 = {
    path: "*",
    name: "page403",
    meta: {
        title: "非法请求"
    },
    component: resolve => require(['@/error/errorpage-403'], resolve)
};

export const page404 = {
    path: "*",
    name: "page404",
    meta: {
        title: "你所在的页面神游啦"
    },
    component: resolve => require(['@/error/errorpage-404'], resolve)
};

export const page504 = {
    path: "/page504",
    name: "page504",
    meta: {
        title: "请求超时"
    },
    component: resolve => require(['@/error/errorpage-504'], resolve)
};

export const page600 = {
  path: "/page600",
  name: "page600",
  meta: {
    title: "请求超时"
  },
  component: resolve => require(['@/error/errorpage-600'], resolve)
};

export const SetUpRouter = {
    path: "/",
    component: Main,
    name: "SetUpRouter",
    // redirect: '/home',
    meta: {
        title: "经销商管理系统"
    },
    children: [{
        path: "SetUp",
        name: "SetUp",
        meta: {title: "经销商管理系统"},
        component: resolve => require(['@/view/setUp/index.vue'], resolve),
        children: [{
            path: "setUpIndex",
            name: "setUpIndex",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/setUp/setUpIndexQA.vue'], resolve)
        }, {
            path: "setUpIndexQA",
            name: "setUpIndexQA",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/setUp/setUpIndex.vue'], resolve)
        }, {
            path: "setUpHospital",
            name: "setUpHospital",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/setUp/setUpHospital.vue'], resolve)
        }, {
            path: "setChannel",
            name: "setChannel",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/setUp/setChannel.vue'], resolve)
        }, {
          path: "InfoApprovalManage",
          name: "InfoApprovalManage",
          meta: {title: "经销商管理系统"},
          component: resolve => require(['@/view/setUp/InfoApprovalManage.vue'], resolve)
        }, {
            path: "setUploadDate",
            name: "setUploadDate",
            meta: {title: "经销商管理系统"},
            component: resolve => require(['@/view/setUp/setUploadDate.vue'], resolve),

        },
            {
                path: "setProtocol",
                name: "setProtocol",
                meta: {title: "经销商管理系统"},
                component: resolve => require(['@/view/setUp/setProtocol.vue'], resolve)
            },
            {
                path: "watermark",
                name: "watermark",
                meta: {title: "经销商管理系统"},
                component: resolve => require(['@/view/setUp/watermark.vue'], resolve)
            },
            {
                path: "tripartiteAgreementManagement",
                name: "tripartiteAgreementManagement",
                meta: {title: "经销商管理系统"},
                component: resolve => require(['@/view/setUp/tripartiteAgreementManagement.vue'], resolve)
            },
            {
                path: "Receive",
                name: "Receive",
                meta: {title: "经销商管理系统"},
                component: resolve => require(['@/view/setUp/Receive.vue'], resolve)
            },
            {
                path: "setBU",
                name: "setBU",
                meta: {title: "经销商管理系统"},
                component: resolve => require(['@/view/setUp/setBu.vue'], resolve)
            },{
                path: "buHead",
                name: "buHead",
                meta: {title: "经销商管理系统"},
                component: resolve => require(['@/view/setUp/buHead.vue'], resolve)
            },{
                path: "setAccountNum",
                name: "setAccountNum",
                meta: {title: "经销商管理系统"},
                component: resolve => require(['@/view/setUp/setAccountNum.vue'], resolve)
            },{
                path: "buProduct",
                name: "buProduct",
                meta: {title: "经销商管理系统"},
                component: resolve => require(['@/view/setUp/bu_product.vue'], resolve)
            },{
                path: "setArea",
                name: "setArea",
                meta: {title: "经销商管理系统"},
                component: resolve => require(['@/view/setUp/setArea.vue'], resolve)
            }
            ,{
                path: "productCheck",
                name: "productCheck",
                meta: {title: "经销商管理系统"},
                component: resolve => require(['@/view/setUp/product_check.vue'], resolve)
            },{
                path: "setProvinceManager",
                name: "setProvinceManager",
                meta: {title: "经销商管理系统"},
                component: resolve => require(['@/view/setUp/setProvinceManager.vue'], resolve)
            },{
                path: "rpl",
                name: "rpl",
                meta: {title: "经销商管理系统"},
                component: resolve => require(['@/view/setUp/rpl.vue'], resolve)
            },{
                path: "base",
                name: "base",
                meta: {title: "经销商管理系统"},
                component: resolve => require(['@/view/setUp/base.vue'], resolve)
            },{
                path: "toProduct",
                name: "toProduct",
                meta: {title: "经销商管理系统"},
                component: resolve => require(['@/view/setUp/toProduct.vue'], resolve)
            },{
                path: "auth",
                name: "auth",
                meta: {title: "经销商管理系统"},
                component: resolve => require(['@/view/setUp/auth.vue'], resolve)
            },{
                path: "apply_role",
                name: "apply_role",
                meta: {title: "经销商管理系统"},
                component: resolve => require(['@/view/setUp/apply_role.vue'], resolve)
            },{
                path: "roleAuth",
                name: "roleAuth",
                meta: {title: "经销商管理系统"},
                component: resolve => require(['@/view/setUp/roleAuth.vue'], resolve)
            },{
                path: "setRegion",
                name: "setRegion",
                meta: {title: "经销商管理系统"},
                component: resolve => require(['@/view/setUp/setRegion.vue'], resolve)
            },{
                path: "setCountry",
                name: "setCountry",
                meta: {title: "经销商管理系统"},
                component: resolve => require(['@/view/setUp/setCountry.vue'], resolve)
            },{
                path: "setUser",
                name: "setUser",
                meta: {title: "经销商管理系统"},
                component: resolve => require(['@/view/setUp/setUser.vue'], resolve)
            }]
    }],
};

export const ToolRouter = {
    path: "/",
    component: Main,
    name: "ToolRouter",
    // redirect: '/home',
    meta: {
        title: "经销商管理系统"
    },
    children: [{
        path: "Tool",
        name: "Tool",
        meta: {title: "经销商管理系统"},
        component: resolve => require(['@/view/tool/Index.vue'], resolve),
        children: [
            {
                path: "toolData",
                name: "toolData",
                meta: {title: "经销商管理系统"},
                component: resolve => require(['@/view/tool/toolData.vue'], resolve)
            }, {
                path: "dealerInventory",
                name: "dealerInventory",
                meta: {title: "经销商管理系统"},
                component: resolve => require(['@/view/tool/dealerInventory.vue'], resolve)
            }, {
                path: "dealerSales",
                name: "dealerSales",
                meta: {title: "经销商管理系统"},
                component: resolve => require(['@/view/tool/dealerSales.vue'], resolve)
            }
            // , {
            //     path: "IMKInfo",
            //     name: "IMKInfo",
            //     meta: {title: "经销商管理系统"},
            //     component: resolve => require(['@/view/tool/IMKInfo.vue'], resolve)
            // }
        ]
    }],
};
export const routers = [
    loginRouter,
    registerRouter,
    IndexRouter,
    IndexTwoRouter,
    InitRouter,
    DistributorRouter,
    DistributorTwoRouter,
    DistributorSecondRouter,
    SetUpRouter,
    ToolRouter,
    WorkflowRouter,
    WorkflowTwoRouter,
    FromPage,
    page403,
    page404,
    page504,
    page600,
    SearchRouter,
    QrcodeRouter

];



// WEBPACK FOOTER //
// ./src/router/routers.js